var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeySkillIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 27.6667C22.4435 27.6667 27.6668 22.4434 27.6668 16C27.6668 9.55672 22.4435 4.33337 16.0002 4.33337C9.55684 4.33337 4.3335 9.55672 4.3335 16C4.3335 22.4434 9.55684 27.6667 16.0002 27.6667ZM16.0002 21C18.7616 21 21.0002 18.7615 21.0002 16C21.0002 13.2386 18.7616 11 16.0002 11C13.2387 11 11.0002 13.2386 11.0002 16C11.0002 18.7615 13.2387 21 16.0002 21Z",
    fill: "#7E869E",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0668 16C27.0668 22.112 22.1121 27.0667 16.0002 27.0667V28.2667C22.7749 28.2667 28.2668 22.7747 28.2668 16H27.0668ZM16.0002 4.93337C22.1121 4.93337 27.0668 9.88809 27.0668 16H28.2668C28.2668 9.22535 22.7749 3.73337 16.0002 3.73337V4.93337ZM4.9335 16C4.9335 9.88809 9.88821 4.93337 16.0002 4.93337V3.73337C9.22547 3.73337 3.7335 9.22535 3.7335 16H4.9335ZM16.0002 27.0667C9.88821 27.0667 4.9335 22.112 4.9335 16H3.7335C3.7335 22.7747 9.22547 28.2667 16.0002 28.2667V27.0667ZM20.4002 16C20.4002 18.4301 18.4302 20.4 16.0002 20.4V21.6C19.093 21.6 21.6002 19.0928 21.6002 16H20.4002ZM16.0002 11.6C18.4302 11.6 20.4002 13.57 20.4002 16H21.6002C21.6002 12.9072 19.093 10.4 16.0002 10.4V11.6ZM11.6002 16C11.6002 13.57 13.5701 11.6 16.0002 11.6V10.4C12.9074 10.4 10.4002 12.9072 10.4002 16H11.6002ZM16.0002 20.4C13.5701 20.4 11.6002 18.4301 11.6002 16H10.4002C10.4002 19.0928 12.9074 21.6 16.0002 21.6V20.4Z",
    fill: "#141F37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.33333V1",
    stroke: "#141F37",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 16L31 16",
    stroke: "#141F37",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 31L16 27.6666",
    stroke: "#141F37",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00016 16H4.3335",
    stroke: "#141F37",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySkillIcon1);
export default __webpack_public_path__ + "static/media/key-skill-icon-1.c5c87a49d7960bf8f7a0ff7ed4884f60.svg";
export { ForwardRef as ReactComponent };